import React from 'react';
import Time from 'react-time';
import moment from 'moment';

CompletionDate.defaultProps = {
  completedAt: null,
};

function CompletionDate({ completedAt, endDate }) {
  if (completedAt) {
    const start = new Date(completedAt);
    start.setHours(0, 0, 0, 0);

    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);

    if (moment(start, 'DD-MM-YYYY').isAfter(moment(end, 'DD-MM-YYYY'))) {
      return <span className="text-danger">Late</span>;
    }

    return <span className="text-success">On Time</span>;
  }

  const now = new Date();
  const end = new Date(endDate);

  now.setHours(0, 0, 0, 0);

  end.setHours(23, 59, 59, 999);

  if (moment(now, 'DD-MM-YYYY').isAfter(moment(end, 'DD-MM-YYYY'))) {
    return <span className="text-danger">Late</span>;
  }

  return (
    <span className="text-muted">
      Due <Time value={endDate} format="M/D/YY" />
    </span>
  );
}

export default CompletionDate;
